import type { AxiosError } from 'axios';

export function isAxiosError(e: unknown): e is AxiosError {
    return (
        e !== null &&
        typeof e === "object" &&
        (e as Pick<AxiosError, "isAxiosError">).isAxiosError === true
    );
}
